import { View, Text, Keyboard, TouchableOpacity, Image, TextInput } from "react-native";
import React, { useEffect, useState } from "react";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { AppImages } from "../../../utility/AppImages";
import { AppScreens } from "../../Utility/AppScreens";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { validateEmail, validateUsername, validateEmailDomain } from "../../../utility/Index";
import { ShowLoader } from "../../../common/ShowLoader";
import { register } from "../../../services/authAPI";
import moment from "moment";
import { toast } from "react-toastify";
import { ScrollView, KeyboardAvoidingView, Platform } from "react-native";
import { TouchableWithoutFeedback } from "react-native";
import PasswordInfoTooltip from "../CommonModal/sign-up-common-components/PasswordInfoTooltip";
import EventSharePopup from "./EventSharePopup/EventSharePopup";
import { MobileEventSharePopup } from "./EventSharePopup/MobileEventSharePopup";
import {
  parseEventShareURL,
  storeEventShareURL,
  getStoredEventShareURL,
  getStoredEventShareAction,
} from "../../../utility/urlUtils";
import { ScreenBGGradientView } from "../../../common/CommonView";

const SignupWebScreen = ({ route }: { route: any }) => {
  const navigation = useNavigation();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [selectMonth, setSelectMonth] = useState(""); // For month
  const [selectDay, setSelectDay] = useState(""); // For day
  const [selectYear, setSelectYear] = useState(""); // For year
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showEventSharePopup, setShowEventSharePopup] = useState(false);
  const [isReferralEditable, setIsReferralEditable] = useState(true);
  const [directReferrerId, setDirectReferrerId] = useState("");
  const [eventShareURL, setEventShareURL] = useState("");
  const [eventId, setEventId] = useState("");
  // Auth type toggle: 'phone' (default) or 'email'
  const [authType, setAuthType] = useState<'phone' | 'email'>('phone');
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+1");

  // Country codes matching landing page
  const countryCodes = [
    { code: "+1", country: "US/CA" },
    { code: "+44", country: "UK" },
    { code: "+91", country: "IN" },
    { code: "+61", country: "AU" },
    { code: "+86", country: "CN" },
    { code: "+81", country: "JP" },
    { code: "+49", country: "DE" },
    { code: "+33", country: "FR" },
    { code: "+39", country: "IT" },
    { code: "+34", country: "ES" },
    { code: "+7", country: "RU" },
    { code: "+55", country: "BR" },
    { code: "+52", country: "MX" },
    { code: "+82", country: "KR" },
    { code: "+65", country: "SG" },
    { code: "+971", country: "AE" },
    { code: "+966", country: "SA" },
    { code: "+27", country: "ZA" },
    { code: "+234", country: "NG" },
    { code: "+254", country: "KE" },
  ];

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const months = moment.months();
  const years = Array.from(
    { length: 120 },
    (_, i) => new Date().getFullYear() - i
  ); // Array of years
  const calculateDaysInMonth = (month: string, year: string) => {
    if (month && year) {
      const days = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
      return Array.from({ length: days }, (_, i) => i + 1);
    }
    return [];
  };
  useEffect(() => {
    if (selectYear && selectMonth && selectDay) {
      handleDateSelect();
    }
  }, [selectYear, selectMonth, selectDay]);

  useEffect(() => {
    if (selectMonth && selectYear) {
      const days = calculateDaysInMonth(selectMonth, selectYear);
      setDaysInMonth(days);
    }
  }, [selectMonth, selectYear]);
  const handleDateSelect = () => {
    const date = `${selectDay}/${selectMonth}/${selectYear}`;
    const validDate = moment(date, "DD/MM/YYYY").isValid();
    if (!validDate) {
      alert("Please select a valid date.");
    } else {
      setSelectDate(moment(date, "DD/MM/YYYY").format("DD/MM/YYYY"));
    }
  };
  const handleSubmit = async () => {
    if (!isPasswordValid) {
      toast.error("Password does not meet the required conditions.");
      return;
    }

    sessionStorage.setItem("showWelcomeAfterSignup", "true");

    if (checkValidation()) {
      // For phone signup, generate a dummy email
      const effectiveEmail = authType === 'phone'
        ? `${username}@dummy.kallout.com`
        : email;

      const normalizedPhone = phoneNumber.replace(/\D/g, '').replace(/^0+/, '');
      const fullPhoneNumber = authType === 'phone'
        ? `${countryCode}${normalizedPhone}`
        : undefined;

      const param = {
        username: username,
        email: effectiveEmail,
        password: password,
        dob: selectDate,
        referralCode: referralCode,
        directReferrerId: directReferrerId,
        authType: authType,
        phoneNumber: fullPhoneNumber,
      };

      try {
        setShowLoader(true);

        const data = await register(param);

        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.success(data.body.message);
          document.cookie = `password=${confirmpassword}; path=/; max-age=86400;`;
          console.log("SignupWebScreen: Password cookie SET for auto-login after verification");

          // Handle unified signup flow context
          const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
          if (signupFlowContextStr) {
            try {
              const signupFlowContext = JSON.parse(signupFlowContextStr);
              console.log("💾 Found signup flow context during signup:", signupFlowContext);

              if (signupFlowContext.postSignupRedirectURL) {
                sessionStorage.setItem(
                  "postConfirmationRedirect",
                  signupFlowContext.postSignupRedirectURL
                );
                console.log(
                  "💾 Stored postConfirmationRedirect from unified context:",
                  signupFlowContext.postSignupRedirectURL
                );
              }
            } catch (error) {
              console.warn("⚠️ Error parsing signup flow context during signup:", error);
            }
          }

          // Fallback: Check for legacy stored event URL for redirect
          const storedEventUrl = getStoredEventShareURL();
          if (storedEventUrl && !sessionStorage.getItem("postConfirmationRedirect")) {
            // Store the event URL temporarily for post-email-confirmation redirect
            sessionStorage.setItem("postConfirmationRedirect", storedEventUrl);
            console.log("💾 Stored legacy event URL for redirect:", storedEventUrl);
          }

          // Fallback: Check for legacy GameShow URL for redirect
          const storedGameShowUrl = sessionStorage.getItem("postSignupRedirect");
          if (storedGameShowUrl && !sessionStorage.getItem("postConfirmationRedirect")) {
            sessionStorage.setItem(
              "postConfirmationRedirect",
              storedGameShowUrl
            );
            console.log(
              "🎮 Moved legacy GameShow redirect URL to postConfirmationRedirect"
            );
          }

          // Remove loginFlowContext after successful signup (keep signupFlowContext for now)
          sessionStorage.removeItem("loginFlowContext");
          sessionStorage.removeItem("gameShowReferralCode");
          sessionStorage.removeItem("gameShowDirectReferrerId");
          sessionStorage.removeItem("postSignupRedirect");
          console.log("🧹 Removed loginFlowContext after successful signup");

          navigateToScreen(navigation, AppScreens.EmailConfirmationWebScreen, {
            username: username,
            authType: authType,
          });
        } else {
          toast.error(
            data.body?.error || "Registration failed. Please try again."
          );
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const validatePassword = (password: string) => {
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const isAtLeast8Characters = password.length >= 8;

    const isValid =
      hasNumber &&
      hasSpecialCharacter &&
      hasUppercase &&
      hasLowercase &&
      isAtLeast8Characters;

    setIsPasswordValid(isValid);
  };

  const handlePasswordChange = (value: string) => {
    setPassword(value);
    validatePassword(value);
    setShowPasswordTooltip(true);
  };

  const handleEventPopupAction = () => {
    setShowEventSharePopup(false);
  };

  useEffect(() => {
    if (route?.params?.referralCode) {
      setReferralCode(route.params.referralCode);
    }
  }, []);

  // Show popup when eventId and eventShareURL are both set
  useEffect(() => {
    if (eventId && eventShareURL && !showEventSharePopup) {
      console.log("🎉 eventId and eventShareURL ready - showing popup");
      setShowEventSharePopup(true);
    }
  }, [eventId, eventShareURL]);

  useEffect(() => {
    console.log("🚀 SignupWebScreen: Checking for event share URL");
    console.log("📋 Route params:", route.params);

    // Check if we're in a GameShow flow - skip event share logic if so
    const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
    if (signupFlowContextStr) {
      try {
        const signupFlowContext = JSON.parse(signupFlowContextStr);
        if (signupFlowContext.flowType === "gameshow") {
          console.log("🎮 GameShow flow detected - skipping event share URL logic");
          return;
        }
      } catch (error) {
        console.warn("⚠️ Error parsing signup flow context:", error);
      }
    }

    // Fallback check for legacy GameShow data
    const gameShowReferralCode = sessionStorage.getItem("gameShowReferralCode");
    const gameShowDirectReferrerId = sessionStorage.getItem(
      "gameShowDirectReferrerId"
    );

    if (gameShowReferralCode || gameShowDirectReferrerId) {
      console.log("🎮 Legacy GameShow data detected - skipping event share URL logic");
      return;
    }

    if (route?.params?.isFromEventShare && route?.params?.eventShareURL) {
      console.log("✅ Event share URL from route params detected");

      const urlData = parseEventShareURL(route.params.eventShareURL);
      console.log("📊 URL Data from route params:", urlData);

      // Use eventId from route.params as fallback (SetupScreen already decoded it)
      const eventId = urlData.eventId || route.params.eventId;
      const referralCode = urlData.referralCode || route.params.invite ?
        (() => {
          try {
            const Base64 = require('js-base64').Base64;
            const decoded = Base64.decode(route.params.invite);
            return JSON.parse(decoded).referralCode;
          } catch (e) { return null; }
        })() : null;
      const directReferrerId = urlData.directReferrerId || route.params.invite ?
        (() => {
          try {
            const Base64 = require('js-base64').Base64;
            const decoded = Base64.decode(route.params.invite);
            return JSON.parse(decoded).directReferrerId;
          } catch (e) { return null; }
        })() : null;

      console.log("🎯 Using eventId:", eventId);
      console.log("🎯 Using referralCode:", referralCode);
      console.log("🎯 Using directReferrerId:", directReferrerId);

      // Always show popup if SetupScreen marked this as event share
      console.log("✅ SetupScreen marked as event share, setting up popup");

      const originalURL = `${window.location.origin}${route.params.eventShareURL}`;
      storeEventShareURL(originalURL);

      // Create unified notification flow context
      const notificationAction = getStoredEventShareAction() || "negotiate";
      const notificationFlowContext = {
        flowType: "notification",
        referralCode: referralCode || "",
        directReferrerId: directReferrerId || "",
        postSignupRedirectURL: originalURL,
        eventId: eventId,
        notificationAction: notificationAction,
        suppressClaimCoinsPopup: true,
        timestamp: Date.now()
      };

      console.log("💾 Notification flow context includes action:", notificationAction);

      // Set localStorage flag to prevent claim coins popup for the day
      const today = new Date().toDateString();
      localStorage.setItem("suppressClaimCoinsPopup_" + today, "true");
      console.log("💾 Notification: Stored localStorage flag to suppress claim coins for today");

      sessionStorage.setItem("signupFlowContext", JSON.stringify(notificationFlowContext));
      console.log("💾 Stored notification flow context:", notificationFlowContext);

      console.log("🎉 Setting up event share popup with eventId:", eventId);

      // Set all state values
      setEventShareURL(route.params.eventShareURL);
      setEventId(eventId);

      if (referralCode) {
        console.log("📝 Setting referral code:", referralCode);
        setReferralCode(referralCode);
        setIsReferralEditable(false);
      }

      if (directReferrerId) {
        console.log("👤 Setting direct referrer:", directReferrerId);
        setDirectReferrerId(directReferrerId);
      }
    } else {
      const urlData = parseEventShareURL();
      console.log("📊 URL Data from current URL:", urlData);

      if (urlData.isEventShareURL) {
        console.log(
          "✅ Event share URL detected from current URL, setting up popup"
        );
        storeEventShareURL(urlData.originalURL);

        // Create unified notification flow context
        const notificationAction = getStoredEventShareAction() || "negotiate";
        const notificationFlowContext = {
          flowType: "notification",
          referralCode: urlData.referralCode || "",
          directReferrerId: urlData.directReferrerId || "",
          postSignupRedirectURL: urlData.originalURL,
          eventId: urlData.eventId,
          notificationAction: notificationAction,
          suppressClaimCoinsPopup: true, // Suppress claim coins popup for notification flows too
          timestamp: Date.now()
        };

        console.log("💾 Notification flow context includes action:", notificationAction);

        // Set localStorage flag to prevent claim coins popup for the day
        const today = new Date().toDateString();
        localStorage.setItem("suppressClaimCoinsPopup_" + today, "true");
        console.log("💾 Notification: Stored localStorage flag to suppress claim coins for today");

        sessionStorage.setItem("signupFlowContext", JSON.stringify(notificationFlowContext));
        console.log("💾 Stored notification flow context:", notificationFlowContext);

        setEventShareURL(window.location.href);
        setEventId(urlData.eventId);

        if (urlData.referralCode) {
          console.log("📝 Setting referral code:", urlData.referralCode);
          setReferralCode(urlData.referralCode);
          setIsReferralEditable(false);
        }

        if (urlData.directReferrerId) {
          console.log("👤 Setting direct referrer:", urlData.directReferrerId);
          setDirectReferrerId(urlData.directReferrerId);
        }

        setShowEventSharePopup(true);
      } else {
        console.log("❌ Not an event share URL");
      }
    }
  }, [route.params]);

  // Unified flow detection useEffect - runs on every mount/focus
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      console.log(
        "🚀 SignupWebScreen: Checking for unified signup flow context on focus"
      );

      // Check for unified signup flow context first
      const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
      console.log("📋 SignupWebScreen focus: signupFlowContext raw:", signupFlowContextStr);

      if (signupFlowContextStr) {
        try {
          const signupFlowContext = JSON.parse(signupFlowContextStr);
          console.log("💾 Found signup flow context on focus:", signupFlowContext);
          console.log("🎯 Flow type:", signupFlowContext.flowType);
          console.log("🎯 Referral code in context:", signupFlowContext.referralCode);
          console.log("🎯 Direct referrer in context:", signupFlowContext.directReferrerId);

          // Pre-fill referral code if available (for ALL flow types)
          if (signupFlowContext.referralCode) {
            console.log(
              "📝 Pre-filling referral code from context:",
              signupFlowContext.referralCode
            );
            setReferralCode(signupFlowContext.referralCode);
            setIsReferralEditable(false);
          } else {
            console.log("⚠️ No referral code found in signup flow context");
          }

          // Set direct referrer ID if available (for ALL flow types)
          if (signupFlowContext.directReferrerId) {
            console.log(
              "👤 Setting direct referrer from context:",
              signupFlowContext.directReferrerId
            );
            setDirectReferrerId(signupFlowContext.directReferrerId);
          } else {
            console.log("⚠️ No direct referrer found in signup flow context");
          }

          return; // Skip legacy GameShow data check if we found context
        } catch (error) {
          console.warn("⚠️ Error parsing signup flow context:", error);
        }
      } else {
        console.log("❌ No signupFlowContext found in sessionStorage on focus");
      }

      // Fallback: Check legacy GameShow sessionStorage data for backward compatibility
      console.log("🔄 Checking legacy GameShow sessionStorage data");
      const gameShowReferralCode = sessionStorage.getItem("gameShowReferralCode");
      const gameShowDirectReferrerId = sessionStorage.getItem(
        "gameShowDirectReferrerId"
      );

      if (gameShowReferralCode || gameShowDirectReferrerId) {
        console.log("💾 Legacy GameShow data found, migrating to unified context");

        // Migrate legacy data to unified context
        const legacySignupFlowContext = {
          flowType: "gameshow",
          referralCode: gameShowReferralCode || "",
          directReferrerId: gameShowDirectReferrerId || "",
          postSignupRedirectURL: sessionStorage.getItem("postSignupRedirect") || "",
          suppressClaimCoinsPopup: true,
          timestamp: Date.now()
        };

        sessionStorage.setItem("signupFlowContext", JSON.stringify(legacySignupFlowContext));

        if (gameShowReferralCode) {
          setReferralCode(gameShowReferralCode);
          setIsReferralEditable(false);
        }

        if (gameShowDirectReferrerId) {
          setDirectReferrerId(gameShowDirectReferrerId);
        }
      }
    });

    // Trigger on initial mount
    const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
    console.log("📋 SignupWebScreen mount: signupFlowContext raw:", signupFlowContextStr);

    if (signupFlowContextStr) {
      try {
        const signupFlowContext = JSON.parse(signupFlowContextStr);
        console.log("💾 Initial mount - Found signup flow context:", signupFlowContext);
        console.log("🎯 Flow type on mount:", signupFlowContext.flowType);
        console.log("🎯 Referral code on mount:", signupFlowContext.referralCode);

        // Pre-fill referral code if available (for ALL flow types)
        if (signupFlowContext.referralCode) {
          console.log("📝 Pre-filling referral code on mount:", signupFlowContext.referralCode);
          setReferralCode(signupFlowContext.referralCode);
          setIsReferralEditable(false);
        } else {
          console.log("⚠️ No referral code found in signup flow context on mount");
        }

        // Set direct referrer ID if available (for ALL flow types)
        if (signupFlowContext.directReferrerId) {
          console.log("👤 Setting direct referrer on mount:", signupFlowContext.directReferrerId);
          setDirectReferrerId(signupFlowContext.directReferrerId);
        } else {
          console.log("⚠️ No direct referrer found in signup flow context on mount");
        }
      } catch (error) {
        console.warn("⚠️ Error parsing signup flow context on mount:", error);
      }
    } else {
      console.log("❌ No signupFlowContext found in sessionStorage on mount");
    }

    return unsubscribe;
  }, [navigation]);

  const isMobile = deviceSize === DEVICE_SIZES.XS ||
    deviceSize === DEVICE_SIZES.SM ||
    deviceSize === DEVICE_SIZES.MD ||
    deviceSize === DEVICE_SIZES.LG;

  if (isMobile) {
    // Mobile layout with fixed header, scrollable form, and fixed footer
    return (
      <TouchableWithoutFeedback
        onPress={() => {
          setShowPasswordTooltip(false);
        }}
      >
        <View style={styles.mobileContainer}>
          <ScreenBGGradientView />

          {/* Fixed Header - Logo */}
          <View style={styles.mobileHeader}>
            <View
              style={{
                borderRadius: 12,
                width: "90%",
                maxWidth: 380,
                height: 260,
                elevation: 20,
              }}
            >
              <Image
                source={AppImages.icMainLogo}
                style={{
                  resizeMode: "contain",
                  width: "100%",
                  height: "100%",
                }}
              />
            </View>
          </View>

          {/* Form Content with Fixed Title */}
          <View style={styles.mobileFormContainer}>
            {/* Fixed Title Section */}
            <View style={styles.mobileFormHeader}>
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_32,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                SignUp
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_13,
                  {
                    color: AppColors.white,
                    marginVertical: 10,
                  },
                ]}
              >
                {"Welcome to Kallout. Please sign up."}{" "}
              </Text>
            </View>

            {/* Scrollable Form Fields */}
            <KeyboardAvoidingView
              style={{ flex: 1 }}
              behavior={Platform.OS === "ios" ? "padding" : "height"}
              keyboardVerticalOffset={Platform.OS === "ios" ? 60 : 0}
            >
              <ScrollView
                style={styles.mobileFormScrollView}
                contentContainerStyle={styles.mobileFormScrollContent}
                keyboardShouldPersistTaps="handled"
                showsVerticalScrollIndicator={false}
              >
                <View style={styles.mobileFormInner}>

                  {/* Auth Type Toggle */}
                  <TouchableOpacity
                    style={{ alignSelf: 'flex-end', marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}
                    onPress={() => setAuthType(authType === 'phone' ? 'email' : 'phone')}
                  >
                    {authType === 'phone' ? (
                      <Image
                        source={require('../../../../assets/auth/use-email-register.svg')}
                        style={{ width: 18, height: 18, marginRight: 6 }}
                        resizeMode="contain"
                      />
                    ) : (
                      <Text style={{ marginRight: 6, fontSize: 16 }}>📱</Text>
                    )}
                    <Text style={{ color: '#DC2626', fontSize: 14, fontWeight: '800', lineHeight: 24 }}>
                      {authType === 'phone' ? 'Use Email address' : 'Use Mobile'}
                    </Text>
                  </TouchableOpacity>

                  {/* Conditional: Phone Number or Email Input */}
                  {authType === 'phone' ? (
                    <View style={{
                      flexDirection: 'row',
                      marginBottom: 10,
                      borderRadius: 8,
                      backgroundColor: AppColors.appGrayColor_1C1C1C,
                      overflow: 'hidden',
                      height: 48,
                      position: 'relative',
                    }}>
                      {/* Country Code Dropdown */}
                      <View style={{
                        justifyContent: 'center',
                        borderRightWidth: 1,
                        borderRightColor: '#374151',
                        paddingHorizontal: 4,
                      }}>
                        <select
                          style={{
                            height: '100%',
                            paddingLeft: 8,
                            paddingRight: 4,
                            background: '#1F2937',
                            border: 'none',
                            color: '#FFFFFF',
                            fontSize: 12,
                            fontFamily: 'Anybody_400Regular',
                            outline: 'none',
                            cursor: 'pointer',
                          }}
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                        >
                          {countryCodes.map((item, index) => (
                            <option key={index} value={item.code} style={{ backgroundColor: '#1F2937', color: '#FFFFFF' }}>
                              {item.code} {item.country}
                            </option>
                          ))}
                        </select>
                      </View>
                      {/* Phone Input */}
                      <TextInput
                        style={{
                          flex: 1,
                          paddingHorizontal: 12,
                          paddingRight: 30,
                          color: AppColors.white,
                          fontSize: 12,
                          fontFamily: 'Anybody_400Regular',
                        }}
                        placeholder="Phone Number"
                        placeholderTextColor={AppColors.white}
                        value={phoneNumber}
                        onChangeText={(text) => setPhoneNumber(text.replace(/[^0-9]/g, ''))}
                        keyboardType="phone-pad"
                        maxLength={15}
                      />
                      {/* Asterisk indicator */}
                      <View style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        justifyContent: 'center',
                        paddingTop: 5,
                        paddingRight: 10,
                      }}>
                        <Text style={[AppFontStyle.REGULAR_ANYBODY_30, { color: AppColors.white }]}>*</Text>
                      </View>
                    </View>
                  ) : (
                    <CommonTextInputWeb
                      placeholder="Email"
                      mainStyle={[styles.inputStyle]}
                      inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                      prefixIconVisibility={false}
                      onChangeText={setEmail}
                      isPassword={false}
                      value={email}
                      onSubmitEditing={() => {
                        Keyboard.dismiss();
                      }}
                      autoCapitalize="none"
                      maxLength={50}
                      isRequired={true}
                    />
                  )}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                    }}
                  >
                    {/* Year Picker */}
                    <View style={{ flex: 0.33 }}>
                      <select
                        style={{
                          height: 37,
                          marginBottom: 10,
                          borderRadius: 8,
                          background: AppColors.appGrayColor_1C1C1C,
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.white,
                          overflow: "auto",
                        }}
                        value={selectYear}
                        onChange={(e) => {
                          setSelectYear(e.target.value);
                          setSelectMonth(""); // Reset month and day if year changes
                          setSelectDay("");
                          setDaysInMonth([]);
                        }}
                      >
                        <option
                          value=""
                          disabled
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1C1C1C',
                            color: '#FFFFFF',
                          }}
                        >
                          Year
                        </option>
                        {years.map((year) => (
                          <option
                            key={year}
                            value={year}
                            style={{
                              ...AppFontStyle.REGULAR_ANYBODY_12,
                              textAlign: "center",
                              backgroundColor: '#1F2937',
                              color: '#FFFFFF',
                            }}
                          >
                            {year}
                          </option>
                        ))}
                      </select>
                    </View>

                    {/* Month Picker */}
                    <View style={{ flex: 0.33 }}>
                      <select
                        style={{
                          height: 37,
                          marginBottom: 10,
                          borderRadius: 8,
                          background: AppColors.appGrayColor_1C1C1C,
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.white,
                        }}
                        value={selectMonth}
                        onChange={(e) => setSelectMonth(e.target.value)}
                        disabled={!selectYear} // Disable if year is not selected
                      >
                        <option
                          value=""
                          disabled
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1F2937',
                            color: '#FFFFFF',
                          }}
                        >
                          Month
                        </option>
                        {months.map((month, index) => (
                          <option
                            key={index}
                            value={index + 1}
                            style={{
                              ...AppFontStyle.REGULAR_ANYBODY_12,
                              textAlign: "center",
                              backgroundColor: '#1F2937',
                              color: '#FFFFFF',
                            }}
                          >
                            {month}
                          </option>
                        ))}
                      </select>
                    </View>

                    {/* Day Picker */}
                    <View style={{ flex: 0.33 }}>
                      <select
                        style={{
                          height: 37,
                          marginBottom: 10,
                          borderRadius: 8,
                          background: AppColors.appGrayColor_1C1C1C,
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.white,
                        }}
                        value={selectDay}
                        onChange={(e) => setSelectDay(e.target.value)}
                        disabled={!selectMonth || !selectYear} // Disable if month or year is not selected
                      >
                        <option
                          value=""
                          disabled
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1F2937',
                            color: '#FFFFFF',
                          }}
                        >
                          Day
                        </option>
                        {daysInMonth.map((day) => (
                          <option
                            key={day}
                            value={day}
                            style={{
                              ...AppFontStyle.REGULAR_ANYBODY_12,
                              textAlign: "center",
                              backgroundColor: '#1F2937',
                              color: '#FFFFFF',
                            }}
                          >
                            {day}
                          </option>
                        ))}
                      </select>
                    </View>
                  </View>
                  {/* USERNAME */}
                  <CommonTextInputWeb
                    placeholder="Username"
                    mainStyle={[styles.inputStyle]}
                    inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                    prefixIconVisibility={false}
                    onChangeText={setUsername}
                    isPassword={false}
                    value={username}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                    }}
                    autoCapitalize="none"
                    maxLength={50}
                    isRequired={true}
                  />
                  {/* Password */}
                  <View style={{ position: "relative" }}>
                    <CommonTextInputWeb
                      placeholder="Password"
                      mainStyle={[styles.inputStyle]}
                      inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                      prefixIconVisibility={false}
                      onChangeText={handlePasswordChange}
                      isPassword={true}
                      value={password}
                      secureTextEntry={showPassword ? false : true}
                      onSubmitEditing={() => {
                        Keyboard.dismiss();
                      }}
                      autoCapitalize="none"
                      onPressEyeIcon={() => {
                        setShowPassword(!showPassword);
                      }}
                      rightIcon={
                        showPassword ? AppImages.icEye : AppImages.icEyeClose
                      }
                      onFocus={() => {
                        if (!isPasswordValid) {
                          setShowPasswordTooltip(true);
                        }
                      }}
                      showEyeIcon={true}
                      maxLength={50}
                      isRequired={true}
                      rightIconStyle={{ width: 20, height: 20 }}
                    />
                    {showPasswordTooltip && !isPasswordValid && (
                      <PasswordInfoTooltip
                        styles={styles}
                        password={password}
                        setShowPasswordTooltip={setShowPasswordTooltip}
                        showPasswordTooltip={showPasswordTooltip}
                      />
                    )}
                  </View>

                  {/* Confirm Password */}
                  <CommonTextInputWeb
                    placeholder="Confirm Password"
                    mainStyle={[styles.inputStyle, { zIndex: -1 }]}
                    inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                    prefixIconVisibility={false}
                    onChangeText={setConfirmPassword}
                    isPassword={true}
                    value={confirmpassword}
                    secureTextEntry={showConfirmPassword ? false : true}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                      handleSubmit();
                    }}
                    autoCapitalize="none"
                    onPressEyeIcon={() => {
                      setShowConfirmPassword(!showConfirmPassword);
                    }}
                    rightIcon={
                      showConfirmPassword ? AppImages.icEye : AppImages.icEyeClose
                    }
                    showEyeIcon={true}
                    maxLength={50}
                    isRequired={true}
                    rightIconStyle={{ width: 20, height: 20 }}
                  />
                  {/* Referral Code (Optional) */}
                  <CommonTextInputWeb
                    placeholder="Referral Code"
                    mainStyle={[styles.inputStyle, { zIndex: -1 }]}
                    inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                    prefixIconVisibility={false}
                    onChangeText={setReferralCode}
                    isPassword={false}
                    value={referralCode}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                    }}
                    autoCapitalize="none"
                    maxLength={50}
                    isRequired={true}
                    editable={isReferralEditable}
                  />

                  {/* Sign up */}
                  <TouchableOpacity
                    style={[
                      styles.signUpButton,
                      {
                        zIndex: -1,
                      },
                    ]}
                    onPress={handleSubmit}
                  >
                    <Text
                      style={[AppFontStyle.BOLD_ANYBODY_14, styles.signUpText]}
                    >
                      Sign up
                    </Text>
                  </TouchableOpacity>

                  {/* Have an Account? Sign In */}
                  <View
                    style={{
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      marginVertical: 20,
                    }}
                  >
                    <View style={{ flexDirection: "row", gap: 5 }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: "white",
                          },
                        ]}
                      >
                        Have an Account?{" "}
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          // When switching from signup to login, preserve redirect info but clear welcome flag
                          const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
                          if (signupFlowContextStr) {
                            try {
                              const signupFlowContext = JSON.parse(signupFlowContextStr);
                              // Create login context from signup context (but keep signupFlowContext alive)
                              const loginFlowContext = {
                                flowType: signupFlowContext.flowType,
                                referralCode: signupFlowContext.referralCode || "",
                                directReferrerId: signupFlowContext.directReferrerId || "",
                                postLoginRedirectURL: signupFlowContext.postSignupRedirectURL || "",
                                suppressClaimCoinsPopup: signupFlowContext.suppressClaimCoinsPopup,
                                timestamp: Date.now(),
                              };
                              sessionStorage.setItem("loginFlowContext", JSON.stringify(loginFlowContext));
                              console.log("💾 SignupWebScreen: Created loginFlowContext from signupFlowContext:", loginFlowContext);
                              console.log("💾 SignupWebScreen: Keeping both contexts alive until API call succeeds");
                            } catch (error) {
                              console.warn("Error converting signup to login context:", error);
                            }
                          }
                          // Clear signup-specific flags only
                          sessionStorage.removeItem("showWelcomeAfterSignup");
                          navigateToScreen(navigation, AppScreens.LoginWebScreen);
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            {
                              color: "white",
                            },
                          ]}
                        >
                          {" "}
                          Sign In{" "}
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_11,
                        { color: AppColors.white, marginTop: 20 },
                      ]}
                    >
                      By signing up, you agree to our Privacy Policy and Terms of
                      Service.
                    </Text>
                  </View>
                </View>
              </ScrollView>
            </KeyboardAvoidingView>
          </View>

          {/* Relative Footer - Platform Icons */}
          <View style={styles.mobileFooter}>
            <Image
              source={AppImages.icYoutubeLogo}
              style={{
                width: 56,
                height: 56,
                marginRight: 8,
              }}
              resizeMode="contain"
            />
            <Image
              source={AppImages.icTwitchLogo}
              style={{
                width: 56,
                height: 56,
              }}
              resizeMode="contain"
            />
          </View>

          {<ShowLoader showIndicater={showLoader} isBackGround={true} />}

          {showEventSharePopup && (
            <MobileEventSharePopup
              showModal={showEventSharePopup}
              setShowModal={setShowEventSharePopup}
              onActionPress={handleEventPopupAction}
              eventShareURL={eventShareURL}
              eventId={eventId}
            />
          )}
        </View>
      </TouchableWithoutFeedback>
    );
  }

  // Desktop layout (unchanged)
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        setShowPasswordTooltip(false);
      }}
    >
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        keyboardShouldPersistTaps="handled"
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.container}>
          <ScreenBGGradientView />
          <View style={styles.rightWrapper}>
            <View
              style={{
                paddingLeft: "15%",
                paddingRight: 0,
              }}
            >
              {/* SignUP */}
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_32,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                SignUp
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_13,
                  {
                    color: AppColors.white,
                    marginVertical: 10,
                  },
                ]}
              >
                {"Welcome to Kallout. Please sign up."}{" "}
              </Text>

              <ScrollView
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ flexGrow: 1 }}
              >
                {/* Auth Type Toggle */}
                <TouchableOpacity
                  style={{ alignSelf: 'flex-end', marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}
                  onPress={() => setAuthType(authType === 'phone' ? 'email' : 'phone')}
                >
                  {authType === 'phone' ? (
                    <Image
                      source={require('../../../../assets/auth/use-email-register.svg')}
                      style={{ width: 18, height: 18, marginRight: 6 }}
                      resizeMode="contain"
                    />
                  ) : (
                    <Text style={{ marginRight: 6, fontSize: 16 }}>📱</Text>
                  )}
                  <Text style={{ color: '#DC2626', fontSize: 14, fontWeight: '800', lineHeight: 24 }}>
                    {authType === 'phone' ? 'Use Email address' : 'Use Mobile'}
                  </Text>
                </TouchableOpacity>

                {/* Conditional: Phone Number or Email Input */}
                {authType === 'phone' ? (
                  <View style={{
                    flexDirection: 'row',
                    marginBottom: 10,
                    borderRadius: 8,
                    backgroundColor: AppColors.appGrayColor_1C1C1C,
                    overflow: 'hidden',
                    height: 48,
                    position: 'relative',
                  }}>
                    {/* Country Code Dropdown */}
                    <View style={{
                      justifyContent: 'center',
                      borderRightWidth: 1,
                      borderRightColor: '#374151',
                      paddingHorizontal: 4,
                    }}>
                      <select
                        style={{
                          height: '100%',
                          paddingLeft: 8,
                          paddingRight: 4,
                          background: '#1F2937',
                          border: 'none',
                          color: '#FFFFFF',
                          fontSize: 12,
                          fontFamily: 'Anybody_400Regular',
                          outline: 'none',
                          cursor: 'pointer',
                        }}
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                      >
                        {countryCodes.map((item, index) => (
                          <option key={index} value={item.code} style={{ backgroundColor: '#1F2937', color: '#FFFFFF' }}>
                            {item.code} {item.country}
                          </option>
                        ))}
                      </select>
                    </View>
                    {/* Phone Input */}
                    <TextInput
                      style={{
                        flex: 1,
                        paddingHorizontal: 12,
                        paddingRight: 30,
                        color: AppColors.white,
                        fontSize: 12,
                        fontFamily: 'Anybody_400Regular',
                      }}
                      placeholder="Phone Number"
                      placeholderTextColor={AppColors.white}
                      value={phoneNumber}
                      onChangeText={(text) => setPhoneNumber(text.replace(/[^0-9]/g, ''))}
                      keyboardType="phone-pad"
                      maxLength={15}
                    />
                    {/* Asterisk indicator */}
                    <View style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      bottom: 0,
                      justifyContent: 'center',
                      paddingTop: 5,
                      paddingRight: 10,
                    }}>
                      <Text style={[AppFontStyle.REGULAR_ANYBODY_30, { color: AppColors.white }]}>*</Text>
                    </View>
                  </View>
                ) : (
                  <CommonTextInputWeb
                    placeholder="Email"
                    mainStyle={[styles.inputStyle]}
                    inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                    prefixIconVisibility={false}
                    onChangeText={setEmail}
                    isPassword={false}
                    value={email}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                    }}
                    autoCapitalize="none"
                    maxLength={50}
                    isRequired={true}
                  />
                )}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: 10,
                  }}
                >
                  {/* Year Picker */}
                  <View style={{ flex: 0.33 }}>
                    <select
                      style={{
                        // width:
                        //   deviceSize === DEVICE_SIZES.SM ||
                        //   deviceSize === DEVICE_SIZES.XS
                        //     ? 90
                        //     : 120,
                        height: 37,
                        marginBottom: 10,
                        borderRadius: 8,
                        background: AppColors.appGrayColor_1C1C1C,
                        fontFamily: "Anybody_400Regular",
                        fontSize: 12,
                        color: AppColors.white,
                        overflow: "auto",
                      }}
                      value={selectYear}
                      onChange={(e) => {
                        setSelectYear(e.target.value);
                        setSelectMonth(""); // Reset month and day if year changes
                        setSelectDay("");
                        setDaysInMonth([]);
                      }}
                    >
                      <option
                        value=""
                        disabled
                        style={{
                          ...AppFontStyle.REGULAR_ANYBODY_12,
                          textAlign: "center",
                          backgroundColor: '#1C1C1C',
                          color: '#FFFFFF',
                        }}
                      >
                        Year
                      </option>
                      {years.map((year) => (
                        <option
                          key={year}
                          value={year}
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1F2937',
                            color: '#FFFFFF',
                          }}
                        >
                          {year}
                        </option>
                      ))}
                    </select>
                  </View>

                  {/* Month Picker */}
                  <View style={{ flex: 0.33 }}>
                    <select
                      style={{
                        // width:
                        //   deviceSize === DEVICE_SIZES.SM ||
                        //   deviceSize === DEVICE_SIZES.XS
                        //     ? 90
                        //     : 120,
                        height: 37,
                        marginBottom: 10,
                        borderRadius: 8,
                        background: AppColors.appGrayColor_1C1C1C,
                        fontFamily: "Anybody_400Regular",
                        fontSize: 12,
                        color: AppColors.white,
                      }}
                      value={selectMonth}
                      onChange={(e) => setSelectMonth(e.target.value)}
                      disabled={!selectYear} // Disable if year is not selected
                    >
                      <option
                        value=""
                        disabled
                        style={{
                          ...AppFontStyle.REGULAR_ANYBODY_12,
                          textAlign: "center",
                          backgroundColor: '#1C1C1C',
                          color: '#FFFFFF',
                        }}
                      >
                        Month
                      </option>
                      {months.map((month, index) => (
                        <option
                          key={index}
                          value={index + 1}
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1F2937',
                            color: '#FFFFFF',
                          }}
                        >
                          {month}
                        </option>
                      ))}
                    </select>
                  </View>

                  {/* Day Picker */}
                  <View style={{ flex: 0.33 }}>
                    <select
                      style={{
                        // width:
                        //   deviceSize === DEVICE_SIZES.SM ||
                        //   deviceSize === DEVICE_SIZES.XS
                        //     ? 90
                        //     : 120,
                        height: 37,
                        marginBottom: 10,
                        borderRadius: 8,
                        background: AppColors.appGrayColor_1C1C1C,
                        fontFamily: "Anybody_400Regular",
                        fontSize: 12,
                        color: AppColors.white,
                      }}
                      value={selectDay}
                      onChange={(e) => setSelectDay(e.target.value)}
                      disabled={!selectMonth || !selectYear} // Disable if month or year is not selected
                    >
                      <option
                        value=""
                        disabled
                        style={{
                          ...AppFontStyle.REGULAR_ANYBODY_12,
                          textAlign: "center",
                          backgroundColor: '#1C1C1C',
                          color: '#FFFFFF',
                        }}
                      >
                        Day
                      </option>
                      {daysInMonth.map((day) => (
                        <option
                          key={day}
                          value={day}
                          style={{
                            ...AppFontStyle.REGULAR_ANYBODY_12,
                            textAlign: "center",
                            backgroundColor: '#1F2937',
                            color: '#FFFFFF',
                          }}
                        >
                          {day}
                        </option>
                      ))}
                    </select>
                  </View>
                </View>
                {/* USERNAME */}
                <CommonTextInputWeb
                  placeholder="Username"
                  mainStyle={[styles.inputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                  prefixIconVisibility={false}
                  onChangeText={setUsername}
                  isPassword={false}
                  value={username}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  isRequired={true}
                />
                {/* Password */}
                <View style={{ position: "relative" }}>
                  <CommonTextInputWeb
                    placeholder="Password"
                    mainStyle={[styles.inputStyle]}
                    inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                    prefixIconVisibility={false}
                    onChangeText={handlePasswordChange}
                    isPassword={true}
                    value={password}
                    secureTextEntry={showPassword ? false : true}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                    }}
                    autoCapitalize="none"
                    onPressEyeIcon={() => {
                      setShowPassword(!showPassword);
                    }}
                    rightIcon={
                      showPassword ? AppImages.icEye : AppImages.icEyeClose
                    }
                    onFocus={() => {
                      if (!isPasswordValid) {
                        setShowPasswordTooltip(true);
                      }
                    }}
                    showEyeIcon={true}
                    maxLength={50}
                    isRequired={true}
                    rightIconStyle={{ width: 20, height: 20 }}
                  />
                  {showPasswordTooltip && !isPasswordValid && (
                    <PasswordInfoTooltip
                      styles={styles}
                      password={password}
                      setShowPasswordTooltip={setShowPasswordTooltip}
                      showPasswordTooltip={showPasswordTooltip}
                    />
                  )}
                </View>

                {/* Confirm Password */}
                <CommonTextInputWeb
                  placeholder="Confirm Password"
                  mainStyle={[styles.inputStyle, { zIndex: -1 }]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                  prefixIconVisibility={false}
                  onChangeText={setConfirmPassword}
                  isPassword={true}
                  value={confirmpassword}
                  secureTextEntry={showConfirmPassword ? false : true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                    handleSubmit();
                  }}
                  autoCapitalize="none"
                  onPressEyeIcon={() => {
                    setShowConfirmPassword(!showConfirmPassword);
                  }}
                  rightIcon={
                    showConfirmPassword ? AppImages.icEye : AppImages.icEyeClose
                  }
                  showEyeIcon={true}
                  maxLength={50}
                  isRequired={true}
                  rightIconStyle={{ width: 20, height: 20 }}
                />
                {/* Referral Code (Optional) */}
                <CommonTextInputWeb
                  placeholder="Referral Code"
                  mainStyle={[styles.inputStyle, { zIndex: -1 }]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                  prefixIconVisibility={false}
                  onChangeText={setReferralCode}
                  isPassword={false}
                  value={referralCode}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  isRequired={true}
                  editable={isReferralEditable}
                />

                {/* Sign up */}

                <TouchableOpacity
                  style={[
                    styles.signUpButton,
                    {
                      zIndex: -1,
                    },
                  ]}
                  onPress={handleSubmit}
                // disabled={!isPasswordValid}
                >
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_14, styles.signUpText]}
                  >
                    Sign up
                  </Text>
                </TouchableOpacity>
                {/* Have an Account? Sign In */}
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginVertical: 20,
                  }}
                >
                  <View style={{ flexDirection: "row", gap: 5 }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: "white",
                        },
                      ]}
                    >
                      Have an Account?{" "}
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        // When switching from signup to login, preserve redirect info but clear welcome flag
                        const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
                        if (signupFlowContextStr) {
                          try {
                            const signupFlowContext = JSON.parse(signupFlowContextStr);
                            // Create login context from signup context (but keep signupFlowContext alive)
                            const loginFlowContext = {
                              flowType: signupFlowContext.flowType,
                              referralCode: signupFlowContext.referralCode || "",
                              directReferrerId: signupFlowContext.directReferrerId || "",
                              postLoginRedirectURL: signupFlowContext.postSignupRedirectURL || "",
                              suppressClaimCoinsPopup: signupFlowContext.suppressClaimCoinsPopup,
                              timestamp: Date.now(),
                            };
                            sessionStorage.setItem("loginFlowContext", JSON.stringify(loginFlowContext));
                            console.log("💾 SignupWebScreen: Created loginFlowContext from signupFlowContext:", loginFlowContext);
                            console.log("💾 SignupWebScreen: Keeping both contexts alive until API call succeeds");
                          } catch (error) {
                            console.warn("Error converting signup to login context:", error);
                          }
                        }
                        // Clear signup-specific flags only
                        sessionStorage.removeItem("showWelcomeAfterSignup");
                        navigateToScreen(navigation, AppScreens.LoginWebScreen);
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_14,
                          {
                            color: "white",
                          },
                        ]}
                      >
                        {" "}
                        Sign In{" "}
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_11,
                      { color: AppColors.white, marginTop: 20 },
                    ]}
                  >
                    By signing up, you agree to our Privacy Policy and Terms of
                    Service.
                  </Text>
                </View>
              </ScrollView>
            </View>
          </View>
          {/* Desktop logo on right side */}
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              paddingRight: "5%",
              flex: 0.6,
            }}
          >
            <View
              style={{
                borderRadius: 12,
                width: 764,
                height: 468,
              }}
            >
              <Image
                source={AppImages.icMainLogo}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                resizeMode="stretch"
              />
            </View>
          </View>

          {/* Desktop platform icons */}
          <View
            style={[
              styles.socialLogosContainer,
              {
                flexDirection: "row",
                position: "absolute",
                bottom: 20,
                right: 30,
                alignItems: "center",
                zIndex: 1000,
              },
            ]}
          >
            <Image
              source={AppImages.icYoutubeLogo}
              style={{
                width: 56,
                height: 56,
                marginRight: 8,
              }}
              resizeMode="contain"
            />

            <Image
              source={AppImages.icTwitchLogo}
              style={{
                width: 56,
                height: 56,
              }}
              resizeMode="contain"
            />
          </View>

          {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
        </View>

        {showEventSharePopup && (
          <EventSharePopup
            showModal={showEventSharePopup}
            setShowModal={setShowEventSharePopup}
            onActionPress={handleEventPopupAction}
            eventShareURL={eventShareURL}
            eventId={eventId}
          />
        )}
      </ScrollView>
    </TouchableWithoutFeedback>
  );
  function ageValidation() {
    if (selectDate !== "") {
      const today = moment(); // Get today's date
      const birthDate = moment(selectDate, "DD/MM/YYYY"); // Parse selectDate as a moment object

      const age = today.diff(birthDate, "years"); // Calculate age
      return age >= 18;
    }
  }
  function checkValidation() {
    // Validate based on auth type
    if (authType === 'email') {
      if (email == "") {
        toast.error("Please Enter Email");
        return false;
      } else if (!validateEmail(email)) {
        toast.error("Please Enter a Valid Email");
        return false;
      } else if (!validateEmailDomain(email)) {
        toast.error("Email domain is not allowed. Please use a supported email provider.");
        return false;
      }
    } else {
      // Phone validation - most countries have 7-10 digit phone numbers (without country code)
      const digitsOnly = phoneNumber.replace(/\D/g, '').replace(/^0+/, '');
      if (phoneNumber === "") {
        toast.error("Please Enter Phone Number");
        return false;
      } else if (digitsOnly.length < 7) {
        toast.error("Phone number is too short. Please enter a valid phone number.");
        return false;
      } else if (digitsOnly.length > 10) {
        toast.error("Phone number is too long. Please enter up to 10 digits (without country code).");
        return false;
      }
    }

    if (username == "") {
      toast.error("Please Enter Username");
      return false;
    } else if (!validateUsername(username)) {
      toast.error(
        "Please remove uppercase letters or special characters from username"
      );
      return false;
    } else if (password == "") {
      toast.error("Please Enter Password");
      return false;
    } else if (confirmpassword == "") {
      toast.error("Please Enter Confirm Password");
      return false;
    } else if (password != confirmpassword) {
      toast.error("Password and Confirm Password are not same");
      return false;
    } else if (selectDate == "") {
      toast.error("Please select the birthdate");
      return false;
    } else if (!ageValidation()) {
      toast.error("Sorry, you must be at least 18 years old to register.");
      return false;
    } else if (referralCode == "") {
      toast.error("Referral code required");
      return false;
    }
    return true;
  }
};

export default SignupWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    tooltip: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      top: 60,
      left: 0,
      right: 0,
      padding: 10,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: AppColors.appBlueColor_3A5175,
      marginTop: 5,
      position: "absolute",
      width: "100%",
      zIndex: 1000,
      elevation: 1000,
    },

    // Mobile-specific styles
    mobileContainer: {
      flex: 1,
      backgroundColor: "transparent",
    },
    mobileHeader: {
      alignItems: "center",
      marginTop: 10, // Same as LoginWebScreen
      paddingHorizontal: 20,
      zIndex: 1,
    },
    mobileFormContainer: {
      flex: 1,
      marginTop: 10,
    },
    mobileFormHeader: {
      paddingHorizontal: "5%",
      paddingTop: 10,
    },
    mobileFormScrollView: {
      flex: 1,
    },
    mobileFormScrollContent: {
      flexGrow: 1,
    },
    mobileFormInner: {
      paddingHorizontal: "5%",
      paddingBottom: 20,
    },
    mobileFooter: {
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: 15,
      paddingBottom: 10,
      paddingTop: 10,
    },

    // Desktop styles
    container: {
      flex: 1,
      flexDirection: "row",
      gap: 30,
    },
    shodowTop: {
      height: "100%",
      width: "100%",
      position: "absolute",
      resizeMode: "stretch",
    },

    rightWrapper: {
      flex: 0.4,
      justifyContent: "center",
    },

    inputStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginBottom: 10,
    },
    signUpButton: {
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: AppColors.buttonRed_DC2626,
      borderRadius: 32,
      marginTop: 10,
      paddingVertical: 16,
      marginHorizontal: "15%",
    },
    signUpText: {
      paddingVertical: 0,
    },
    logoContainer: {
      alignItems: "center",
      top: 20,
      marginBottom: 20,
      position: "absolute",
    },
    socialLogosContainer: {
      flexDirection: "row",
      alignItems: "center",
    },
    appLogoStyle: {
      height: 100,
      width: 400,
      marginTop: "8%",
      resizeMode: "contain",
    },
    gameImage: {
      width: "100%",
      height: "75%",
      left: "-4%",
      resizeMode: "stretch",
    },
  },
  {
    // Mobile styles are now handled in the mobile layout branch
    // Only keep desktop-specific overrides if needed
  }
);
